import $ from './jquery.slim.min.js';

export class AfterpayLocal {

  async initAfterpay() {
    if (this.initButton) {
      AfterPay.initializeForPopup({
        countryCode: this.cart.shippingZone,
        onCommenceCheckout: this.onCommenceCheckout.bind(this),
        onShippingAddressChange: this.onShippingAddressChange.bind(this),
        shippingOptionRequired: true,
        onComplete: this.onComplete.bind(this),
        target: '#rtc-afterpay-init-button',
        shippingOptionRequired: true,
      });
    }
  }

  async setupWidget() {
    const afterpayWidget = new AfterPay.Widgets.PaymentSchedule({
       token: this.token,
       target: '#rtc-afterpay-widget',
       locale: 'en-US',
       onReady: function (event) {
         // Fires when the widget is ready to accept updates.
       },
       onChange: function (event) {
         // Fires after each update and on any other state changes.
         // See "Getting the widget's state" for more details.
       },
       onError: function (event) {
         // See "Handling widget errors" for more details.
       },
     });

  }

  async onCommenceCheckout(actions) {
    const data = await this.apiClient.initAfterpay({ origin: window.location.href });
    this.token = data.token;
    actions.resolve(data.token);
  }

  async onShippingAddressChange(data, actions) {
    console.log('onShippingAddressChange');
    console.log(data);
    const update = await this.apiClient.localizeAfterpay(data);
    actions.resolve(update.options);
    //console.log(update);
    //actions.reject(AfterPay.CONSTANTS.SHIPPING_UNSUPPORTED);
  }

  async onComplete(data) {
    if (data.data.status === "SUCCESS") {
      this.setupWidget();
      this.readyToCheckout = true;
      this.initButton.style.display = "none";
      this.completeButton.style.display = "block";

    }
  }

  loadScript() {
    const head = document.getElementsByTagName("head")[0];
    const newScriptTag = document.createElement('script')
    newScriptTag.type = 'text/javascript'
    if (checkout.settings.afterpayMode === "sandbox") {
      newScriptTag.src  = "https://portal.sandbox.afterpay.com/afterpay.js";
    } else {
      newScriptTag.src = "https://portal.afterpay.com/afterpay.js";
    }
    newScriptTag.onload = this.initAfterpay.bind(this);
    head.appendChild(newScriptTag)
  }

  constructor(props) {
    this.initButton = document.getElementById('rtc-afterpay-init-button');
    this.completeButton = document.getElementById('rtc-afterpay-complete-button');
    this.widget = document.getElementById('rtc-afterpay-widget');
    this.readyToCheckout = true;

    this.apiClient = props.apiClient;
    this.settings = props.settings;
    this.cart = props.cart;
    this.doCharge = props.doCharge;

    if (this.initButton) {
      this.loadScript();
    }

    $(document).on("click", "#rtc-afterpay-complete-button", async (e) => {
      if (this.readyToCheckout) {
        const result = await this.doCharge({
          afterpayOrderToken: this.token
        });
        if (result) {
          window.location = document.getElementById('rtc-afterpay-complete-button').dataset.nextUrl;
        }
      }
    });

  }
}
